import React from 'react';
import { MediaKitPhoto } from '../services/mediaKitService';

interface MediaKitPhotoCollageProps {
    photos: MediaKitPhoto[];
}

/**
 * Photo grid for the completed media kit hero.
 * Fixed footprint: 1 photo fills the area; 2–4 photos tile the same rectangle (design layout).
 */
export default function MediaKitPhotoCollage({ photos }: MediaKitPhotoCollageProps) {
    const visible = photos.slice(0, 4);
    const count = visible.length;

    if (count === 0) {
        return (
            <div
                className="media-kit-photo-collage media-kit-photo-collage--empty media-kit-photo-collage--3"
                aria-hidden="true"
                data-testid="media-kit-photo-collage-empty"
            >
                <div className="media-kit-photo-collage-skeleton media-kit-photo-collage-item--1" />
                <div className="media-kit-photo-collage-skeleton media-kit-photo-collage-item--2" />
                <div className="media-kit-photo-collage-skeleton media-kit-photo-collage-item--3" />
            </div>
        );
    }

    const layoutClass =
        count === 1
            ? 'media-kit-photo-collage--1'
            : count === 2
              ? 'media-kit-photo-collage--2'
              : count === 3
                ? 'media-kit-photo-collage--3'
                : 'media-kit-photo-collage--4';

    return (
        <div className={`media-kit-photo-collage ${layoutClass}`} data-photo-count={count}>
            {visible.map((photo, index) => (
                <img
                    key={photo.id}
                    src={photo.imageUrl}
                    alt=""
                    className={`media-kit-photo-collage-item media-kit-photo-collage-item--${index + 1}`}
                />
            ))}
        </div>
    );
}
